'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconForklift, iconForkliftTag } from '@ni/nimble-components/dist/esm/icons/forklift';
import { wrap } from '../../utilities/react-wrapper';

export type { IconForklift };
export { iconForkliftTag };
export const NimbleIconForklift = wrap(IconForklift);